import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

type IProps = {
  value: boolean;
  title?: string;
  subtitle?: string;
};

export const BooleanDisplay: React.FC<IProps> = ({
  value,
  title,
  subtitle
}) => {
  return (
    <Flex flexDirection={'column'}>
      {title && (
        <Flex flexDirection={'column'}>
          <Flex flexDirection={'row'} gap={2}>
            <Text textStyle="headingItem">{title}</Text>
          </Flex>
        </Flex>
      )}
      {subtitle ? (
        <Text textStyle={'textBody'}>{subtitle}</Text>
      ) : (
        <Text textStyle={'textBody'}>{value ? 'Yes' : 'No'}</Text>
      )}
    </Flex>
  );
};
